import { CommonModule } from '@angular/common';
import { Component, inject, OnChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { Checkbox, CheckboxChangeEvent } from 'primeng/checkbox';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-authenticationData',
    standalone: true,
    imports: [CommonModule, SharedModule, TranslateModule, FormsModule],
    templateUrl: './authentication-data.component.html',
    styleUrl: './authentication-data.component.scss',
})
export class AuthenticationDataComponent {

    private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    authDataTitle = 'features.authenticationData.authDataTitle';
    authDataSubtitle1 = 'features.authenticationData.authDataSubtitle1';
    checkAuthData = 'features.authenticationData.checkAuthData';
    infoAuthData = 'features.authenticationData.infoAuthData';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    booleanCheck: boolean = false;

    formGroup!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(24);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {this.isPortraitDevice = value;});

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            auth: new FormControl (false, [Validators.required, Validators.requiredTrue])
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                auth: new FormControl (value.authenticationData.auth ? value.authenticationData.auth : this.booleanCheck , [Validators.required, Validators.requiredTrue])
            });
        }
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onChangeDataAuthentication(event: Event) {
        this.formIsValid();
    }

/*     onChangeDataAuthentication(event: Event) {
    this.formGroup.controls.auth.setValue(true);

        this.formIsValid();
    } */

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.createForm();
        this.saveDataService.saveDataLocal(this.formGroup.value, 'authentication');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/step/authentications/authentication'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'authentication');
        this.router.navigate(['/main/step/documentation'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
